webpackJsonp([103109554505587],{

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.MediaCard = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _link = __webpack_require__(9);
	
	var _dateManager = __webpack_require__(62);
	
	var _standardIcon = __webpack_require__(3717);
	
	var _standardIcon2 = _interopRequireDefault(_standardIcon);
	
	var _styles = __webpack_require__(958);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MediaCardComponent = function (_React$PureComponent) {
		_inherits(MediaCardComponent, _React$PureComponent);
	
		function MediaCardComponent() {
			_classCallCheck(this, MediaCardComponent);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		MediaCardComponent.prototype.render = function render() {
			var _props = this.props,
			    id = _props.id,
			    to = _props.to,
			    title = _props.title,
			    body = _props.body,
			    date = _props.date,
			    background = _props.background,
			    hasVideo = _props.hasVideo;
	
	
			return _react2.default.createElement(
				_link.Link,
				{ className: _styles.wrapperLinkStyle, to: to, 'data-component': 'Card' },
				_react2.default.createElement(
					'article',
					{ className: (0, _styles.wrapperStyle)(background, hasVideo), id: 'item-' + id },
					!background && !hasVideo && _react2.default.createElement('img', { src: _standardIcon2.default, alt: '' }),
					_react2.default.createElement(
						'h1',
						{ className: _styles.titleStyle },
						title
					),
					!background && _react2.default.createElement(
						'p',
						{ className: _styles.bodyStyle },
						body
					),
					_react2.default.createElement(
						'p',
						{ className: _styles.metaDateStyle },
						(0, _dateManager.format)(date)
					)
				)
			);
		};
	
		return MediaCardComponent;
	}(_react2.default.PureComponent);
	
	MediaCardComponent.propTypes = {
		id: _propTypes2.default.string,
		to: _propTypes2.default.string,
		hasVideo: _propTypes2.default.bool,
		title: _propTypes2.default.string,
		body: _propTypes2.default.string,
		date: _propTypes2.default.string,
		background: _propTypes2.default.string
	};
	
	var MediaCard = exports.MediaCard = MediaCardComponent;

/***/ }),

/***/ 957:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(956);
	
	Object.keys(_component).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _component[key];
	    }
	  });
	});

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.metaDateStyle = exports.bodyStyle = exports.titleStyle = exports.wrapperStyle = exports.wrapperLinkStyle = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var _mediaIcon = __webpack_require__(168);
	
	var _mediaIcon2 = _interopRequireDefault(_mediaIcon);
	
	var _mediaIconMobile = __webpack_require__(432);
	
	var _mediaIconMobile2 = _interopRequireDefault(_mediaIconMobile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var padding = 24;
	
	var wrapperLinkStyle = /*#__PURE__*/exports.wrapperLinkStyle = (0, _emotion.css)({
		textDecoration: 'none',
		display: 'block'
	});
	
	var wrapperStyle = exports.wrapperStyle = function wrapperStyle(background, hasVideo) {
		var baseCSS = {
			position: 'relative',
			textDecoration: 'none',
			border: '1px solid ' + _globalStyles.lightGrey,
			borderRadius: '6px',
			backgroundColor: '#fff',
			boxSizing: 'border-box'
		};
		if (background) {
			var _ref;
	
			return (/*#__PURE__*/(0, _emotion.css)(_extends({}, baseCSS, {
					padding: padding + 'px',
					paddingTop: '56.159420289855072%',
					position: 'relative',
					zIndex: '1',
					height: '100%',
					'&:after': _extends({
						borderRadius: '6px 6px 0 0',
						content: "' '",
						display: 'block',
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
						paddingTop: '56.159420289855072%'
					}, hasVideo ? (_ref = {
						background: 'url(' + _mediaIcon2.default + '), linear-gradient(\n\t\t\t\t\t\trgba(0, 0, 0, 0.3), \n\t\t\t\t\t\trgba(0, 0, 0, 0.3)\n\t\t\t\t\t), url(\'' + background + '\')',
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center center, center center, top center',
						backgroundSize: '56px 56px, cover, cover'
					}, _ref['@media (max-width: ' + _globalStyles.mobileMaxWidthBreakpoint + 'px)'] = {
						backgroundImage: 'url(' + _mediaIconMobile2.default + '), url(\'' + background + '\')',
						backgroundSize: '40px 40px, cover, cover'
					}, _ref) : {
						background: 'linear-gradient(\n\t\t\t\t\t\trgba(0, 0, 0, 0.3), \n\t\t\t\t\t\trgba(0, 0, 0, 0.3)\n\t\t\t\t\t), url(\'' + background + '\')',
						backgroundRepeat: 'no-repeat',
						backgroundPosition: 'center center, top center',
						backgroundSize: 'cover, cover'
					}),
					'& h1': {
						marginTop: '24px'
					},
					button: {
						filter: 'brightness(2)'
					}
				}))
			);
		}
	
		return (/*#__PURE__*/(0, _emotion.css)(_extends({}, baseCSS, {
				padding: padding + 'px',
				position: 'relative',
				zIndex: '1',
				height: '100%',
				'& > img': {
					display: 'block',
					marginBottom: '18px'
				}
			}))
		);
	};
	
	var titleStyle = exports.titleStyle = (0, _emotion.cx)(_globalStyles.headingSmallLight, /*#__PURE__*/(0, _emotion.css)({
		marginBottom: '11px'
	}));
	
	var bodyStyle = exports.bodyStyle = (0, _emotion.cx)(_globalStyles.textBlock, /*#__PURE__*/(0, _emotion.css)({
		marginTop: 0,
		marginBottom: '10px'
	}));
	
	var metaDateStyle = /*#__PURE__*/exports.metaDateStyle = (0, _emotion.css)({
		fontSize: '12px',
		lineHeight: '18px',
		margin: 0,
		color: '#8A8B8C'
	});

/***/ }),

/***/ 3717:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.rightStyle = exports.introStyle = exports.sectionsStyle = exports.innerWrapperStyle = undefined;
	
	var _p, _css;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _emotion = __webpack_require__(6);
	
	var _globalStyles = __webpack_require__(4);
	
	var innerWrapperStyle = /*#__PURE__*/exports.innerWrapperStyle = (0, _emotion.css)({
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px'
	});
	
	var sectionsStyle = /*#__PURE__*/exports.sectionsStyle = (0, _emotion.css)({
		borderBottom: '1px solid ' + _globalStyles.lightGrey
	});
	
	var introStyle = /*#__PURE__*/exports.introStyle = (0, _emotion.css)((_css = {
		display: 'table',
		margin: '60px auto',
		padding: '0 20px',
		width: '100%',
		maxWidth: _globalStyles.desktopMaxWidthBreakpoint,
		'& > div': {
			display: 'table-cell',
	
			verticalAlign: 'top',
			'&:first-child': {
				width: '60%'
			}
		}
	}, _css['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		display: 'block',
		'& > div': {
			display: 'block',
			'&:first-child': {
				width: '100%'
			},
			'&:last-child': {
				marginTop: '60px'
			}
		}
	}, _css['& h1'] = _extends({}, _globalStyles.museo900, {
		color: _globalStyles.darkGrey,
		fontSize: '36px',
		lineHeight: '36px',
		marginTop: '0',
		marginBottom: '11px',
		fontWeight: 'normal'
	}), _css['& p'] = (_p = {
		fontSize: '16px',
		lineHeight: '22px',
		color: _globalStyles.grey,
		width: '400px'
	}, _p['@media (max-width: ' + _globalStyles.tabletPortraitMaxWidthBreakpoint + 'px)'] = {
		width: 'auto'
	}, _p), _css['& h2'] = {
		color: _globalStyles.grey,
		fontSize: '10px',
		lineHeight: '12px',
		letterSpacing: '0.5px',
		fontWeight: 'bold',
		textTransform: 'uppercase',
		marginTop: '0',
		marginBottom: '6px'
	}, _css['& span'] = _extends({}, _globalStyles.museo900, {
		display: 'block',
		color: _globalStyles.darkGrey,
		fontSize: '18px',
		lineHeight: '18px'
	}), _css));
	
	var rightStyle = /*#__PURE__*/exports.rightStyle = (0, _emotion.css)({
		'& div:first-child': {
			marginBottom: '39px'
		},
		'& a': {
			color: 'inherit'
		}
	});

/***/ }),

/***/ 1144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _navManager = __webpack_require__(22);
	
	var _pageHeader = __webpack_require__(19);
	
	var _cards = __webpack_require__(17);
	
	var _mediaCard = __webpack_require__(957);
	
	var _mediaOffice = __webpack_require__(1064);
	
	var _globalStyles = __webpack_require__(4);
	
	var _link = __webpack_require__(9);
	
	var _pagination = __webpack_require__(78);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hasVideoAttachment = function hasVideoAttachment(node) {
		return node.attachments && node.attachments.find(function (attachment) {
			return attachment.vimeo_url;
		});
	};
	
	var MediaOfficePage = function (_React$PureComponent) {
		_inherits(MediaOfficePage, _React$PureComponent);
	
		function MediaOfficePage() {
			_classCallCheck(this, MediaOfficePage);
	
			return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
		}
	
		MediaOfficePage.prototype.render = function render() {
			var _props$pathContext = this.props.pathContext,
			    pageNumber = _props$pathContext.pageNumber,
			    totalPages = _props$pathContext.totalPages;
			var _props$data = this.props.data,
			    page = _props$data.page,
			    media = _props$data.media;
	
			var pageSettings = page.edges[0].node;
	
			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: pageSettings.main_heading },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: pageSettings.main_heading })
				),
				_react2.default.createElement(_pageHeader.PageHeader, {
					background: _globalStyles.burnedOrange,
					titleText: pageSettings.main_heading,
					titleTextColor: '#fff',
					subTitleText: pageSettings.main_body,
					subTitleTextColor: '#fff'
				}),
				_react2.default.createElement(
					'section',
					{ className: _mediaOffice.introStyle },
					_react2.default.createElement(
						'div',
						{ className: _mediaOffice.leftStyle },
						_react2.default.createElement(
							'h1',
							null,
							pageSettings.heading
						),
						_react2.default.createElement(
							'p',
							null,
							pageSettings.body
						)
					),
					_react2.default.createElement(
						'div',
						{ className: _mediaOffice.rightStyle },
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'h2',
								null,
								'Phone numbers'
							),
							pageSettings.phone_numbers.map(function (_ref) {
								var number = _ref.number;
								return _react2.default.createElement(
									'span',
									{ key: number },
									number
								);
							})
						),
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'h2',
								null,
								'email address'
							),
							_react2.default.createElement(
								'span',
								null,
								_react2.default.createElement(
									'a',
									{ href: 'mailto:' + pageSettings.email, target: '_blank' },
									pageSettings.email
								)
							)
						)
					)
				),
				_react2.default.createElement(
					'div',
					{ className: _mediaOffice.sectionsStyle },
					_react2.default.createElement(
						'section',
						{ className: (0, _globalStyles.contentSection)('#F6F6F6') },
						_react2.default.createElement(
							'div',
							{ className: _mediaOffice.innerWrapperStyle },
							_react2.default.createElement(
								'div',
								{ className: (0, _globalStyles.cardSection)() },
								_react2.default.createElement(
									_cards.Cards,
									{ columns: 4 },
									media.edges.map(function (_ref2, index) {
										var node = _ref2.node;
										return _react2.default.createElement(_mediaCard.MediaCard, {
											key: index,
											to: (0, _navManager.idToLink)(node.id),
											hasVideo: hasVideoAttachment(node),
											background: node.fields && node.fields.thumbnail_image.childImageSharp.resize.src,
											title: node.title,
											body: node.extract,
											date: node.date
										});
									})
								)
							)
						)
					),
					totalPages !== 1 && _react2.default.createElement(_pagination.Pagination, {
						initialPage: pageNumber,
						pageCount: totalPages,
						onPageChange: function onPageChange(page) {
							(0, _link.navigateTo)(page === 1 ? '/media-office' : '/media-office/' + page);
						}
					})
				)
			);
		};
	
		return MediaOfficePage;
	}(_react2.default.PureComponent);
	
	MediaOfficePage.propTypes = {
		pathContext: _propTypes2.default.shape({
			pageNumber: _propTypes2.default.number.isRequired,
			totalPages: _propTypes2.default.number.isRequired
		}).isRequired,
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						main_heading: _propTypes2.default.string.isRequired,
						main_body: _propTypes2.default.string.isRequired,
						heading: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired,
						phone_numbers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							number: _propTypes2.default.string.isRequired
						})),
						email: _propTypes2.default.string.isRequired
					})
				}))
			}),
			media: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						title: _propTypes2.default.string,
						type: _propTypes2.default.string,
						attachments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
							file: _propTypes2.default.string
						})),
						date: _propTypes2.default.string,
						thumbnail: _propTypes2.default.string
					}).isRequired
				}).isRequired)
			}).isRequired
		}).isRequired
	};
	exports.default = MediaOfficePage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-media-office-index-js-684bd1dacdf68cbfe760.js